import Axios from "axios";
import ConnectionConfig from "@/entity/Connection";

export default class ConnectionsService {
  static async getConnections(): Promise<ConnectionConfig[]> {
    const response = await Axios.get("api/v2/connections");
    return response.data;
  }
}
